// extracted by mini-css-extract-plugin
export var controls = "slider-module--controls--3b93b";
export var frameContainer = "slider-module--frameContainer--fd24f";
export var slider = "slider-module--slider--83f11";